module.exports = __webpack_public_path__ + "static/media/dromma.61cfb759.mp3";